import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { StatusOrdemModel } from "../models/status-ordem.model";

@Injectable()
export class StatusOrdemService {
    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Lista de Basket
     * @param id ID da Basket
     */
    getAll(params: Record<string, unknown>): Observable<ApiPaginationResponseDataNonNullable<StatusOrdemModel>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp !== null && paramHttp !== "") {
            env = "?" + paramHttp;
        }
        return this._http.get<ApiPaginationResponseDataNonNullable<StatusOrdemModel>>(
            this.utilitesService.urlPrefix + "renda-variavel/status-ordem" + env,
            {
                headers: this.authService.getAuthHeaders(),
            }
        );
    }
}
